import { render } from "./AuditTrailTableLoading.vue?vue&type=template&id=763d1361"
import script from "./AuditTrailTableLoading.vue?vue&type=script&lang=js"
export * from "./AuditTrailTableLoading.vue?vue&type=script&lang=js"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__